import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import ProductDescriptions from '../../molecules/product-detail-descriptions';
import ShippingFrom from '../product-properties-shipping-from';
import Details from '../product-properties-details';
import Sizing from '../product-properties-sizing';
import Materials from '../product-properties-materials';
import KeyIngredients from '../product-properties-key-ingredients';
import FullListIngredients from '../product-properties-full-ingredients';
import HowToUse from '../product-properties-how-to-use';
import GoodToKnow from '../product-properties-good-to-know';
import Awards from '../product-properties-awards';

const Properties = styled.div`
  margin-bottom: 3rem;
  color: ${({ theme }) => theme.color.brand};
  line-height: 1.5;
  @media (max-width: ${(props) => props.theme.breakpoint.medium}) {
    order: ${(props) => (props.placement ? `${props.placement}` : '')};
  }
`;

const VALID_PROPERTIES_MAP = {
  'Care Instructions': 'Materials',
  Material: 'Materials',
  'Maisonette Product ID': 'Details',
  'Assembly Required': 'Details',
  'Made to Order': 'Details',
  'Country of Origin': 'Details',
  'Sizing Notes': 'Sizing',
  'Key Ingredients & Benefits': 'KeyIngredients',
  'Full List of Ingredients': 'FullListIngredients',
  'How to Use': 'HowToUse',
  'Good to know': 'GoodToKnow',
  Awards: 'Awards'
};

const ProductProperties = (props) => {
  const sortedProperties = (() => {
    const obj = {};

    props.product.product_properties.forEach((property) => {
      const isValidProperty = VALID_PROPERTIES_MAP[property.property_name];

      if (isValidProperty) {
        if (obj[isValidProperty]) {
          obj[isValidProperty].push(property);
        } else {
          obj[isValidProperty] = [property];
        }
      }
    });

    return obj;
  })();

  return (
    <Properties placement={props.order}>
      <ProductDescriptions
        brand={props.product.brand}
        brandDescription={props.product.brand_description}
        description={props.product.description}
        product={props.product}
      />
      <Materials product={props.product} materials={sortedProperties.Materials} />
      <Details product={props.product} variant={props.variant} details={sortedProperties.Details} />
      <Sizing product={props.product} sizing={sortedProperties.Sizing} />
      <KeyIngredients product={props.product} ingredients={sortedProperties.KeyIngredients} />
      <FullListIngredients
        product={props.product}
        ingredients={sortedProperties.FullListIngredients}
      />
      <HowToUse product={props.product} instructions={sortedProperties.HowToUse} />
      <GoodToKnow product={props.product} goodToKnow={sortedProperties.GoodToKnow} />
      <Awards product={props.product} awards={sortedProperties.Awards} />
      <ShippingFrom
        product={props.product}
        vendor={props.vendor}
        variant={props.variant}
        onVendorChange={props.onVendorChange}
      />
    </Properties>
  );
};

ProductProperties.defaultProps = {
  variant: null,
  vendor: null
};

ProductProperties.propTypes = {
  onVendorChange: PropTypes.func.isRequired,
  product: PropTypes.object.isRequired,
  order: PropTypes.number.isRequired,
  variant: PropTypes.object,
  vendor: PropTypes.number
};

ProductProperties.whyDidYouRender = true;

export default ProductProperties;
